export default __webpack_public_path__ + "static/media/bg-exclusive.296bba50.webp";